import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0d024c',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#ff5252'
      }
    }
  }
})
